export default __webpack_public_path__ + "static/media/heroBg.6d95cfd3.png";